import { lazy, Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AdminShell } from './components/layout/AdminShell';
import { PublicLayout } from './components/layout/PublicLayout';
import { RequireAdmin, RequireAuth } from './components/layout/RouteGuards';
import { Spinner } from './components/ui/Feedback';

const CatalogPage = lazy(() => import('./pages/public/CatalogPage'));
const ProductPage = lazy(() => import('./pages/public/ProductPage'));
const TrackingPage = lazy(() => import('./pages/public/TrackingPage'));
const LoginPage = lazy(() => import('./pages/auth/LoginPage'));
const DashboardPage = lazy(() => import('./pages/admin/DashboardPage'));
const ProductsPage = lazy(() => import('./pages/admin/ProductsPage'));
const CategoriesPage = lazy(() => import('./pages/admin/CategoriesPage'));
const CustomersPage = lazy(() => import('./pages/admin/CustomersPage'));
const OrdersPage = lazy(() => import('./pages/admin/OrdersPage'));
const OrderEditorPage = lazy(() => import('./pages/admin/OrderEditorPage'));
const BatchesPage = lazy(() => import('./pages/admin/BatchesPage'));
const UsersPage = lazy(() => import('./pages/admin/UsersPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <Suspense fallback={<div className="route-loading"><Spinner /></div>}>
      <ScrollToTop />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route index element={<CatalogPage />} />
          <Route path="producto/:slug" element={<ProductPage />} />
          <Route path="seguimiento" element={<TrackingPage />} />
          <Route path="seguimiento/:code" element={<TrackingPage />} />
        </Route>

        <Route path="login" element={<LoginPage />} />

        <Route element={<RequireAuth />}>
          <Route path="admin" element={<AdminShell />}>
            <Route index element={<DashboardPage />} />
            <Route path="productos" element={<ProductsPage />} />
            <Route path="categorias" element={<CategoriesPage />} />
            <Route path="clientes" element={<CustomersPage />} />
            <Route path="pedidos" element={<OrdersPage />} />
            <Route path="pedidos/nuevo" element={<OrderEditorPage />} />
            <Route path="pedidos/:id" element={<OrderEditorPage />} />
            <Route path="lotes" element={<BatchesPage />} />
            <Route
              path="usuarios"
              element={
                <RequireAdmin>
                  <UsersPage />
                </RequireAdmin>
              }
            />
          </Route>
        </Route>

        <Route path="catalogo" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
